import * as yup from "yup";

const yupTypeValidator = (item: any) => {
  let schema: yup.AnySchema | undefined;

  if (item.htmlType === "selectobj" || item.htmlType === "radioobj") {
    schema = yup.string().label(item.title);
  } else if (
    item.dbType === "string" ||
    item.dbType === "varchar" ||
    item.dbType === "datetime"
  ) {
    schema = item.htmlType === "email"
      ? yup.string().email().label(item.title)
      : yup.string().label(item.title);

    if (item.minLength) {
      schema = (schema as yup.StringSchema).min(item.minLength);
    }
  } else if (item.dbType === "bool" || item.dbType === "bit") {
    schema = yup.boolean().label(item.title);
  } else if (
    item.dbType === "int" ||
    item.dbType === "bigint" ||
    item.dbType === "decimal" ||
    item.dbType === "money"
  ) {
    schema = yup.number().label(item.title);
  } else if (item.dbType === "date") {
    schema = yup.date().label(item.title);
  }

  if (!schema) return undefined;

  if (item.required) {
    return schema.required();
  }

  return schema.transform((value, originalValue) =>
    originalValue === "" ? undefined : value
  ).notRequired();
};

export default yupTypeValidator;
